import Styles from './styles.module.scss';

export const NullEditorItem = ({ name, value }: { name: string; value: null | undefined }) => {
	return (
		<li>
			<h4>{`${name}:`}</h4>
			<span className={Styles.null}>{value === null ? 'null' : 'undefined'}</span>
		</li>
	);
};
